import { Choice } from '@model';

export class MultiChoiceFilter {
  selections: Choice[];
  selected: string[];
}
